export const getDefaultOrgRole = (orgRoleMap) => {
    var _a;
    const [defaultRole] = (_a = Object.entries(orgRoleMap).find(([, role]) => !!role.default)) !== null && _a !== void 0 ? _a : [];
    return defaultRole;
};
